import React, { useCallback } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";

import { useDropzone } from "react-dropzone";

import { BiDownload } from "react-icons/bi";
import {
  BsFillCameraVideoFill,
  BsFillCloudArrowDownFill,
  BsFillFileEarmarkCheckFill,
  BsFillFileEarmarkFill,
  BsYoutube,
} from "react-icons/bs";

import "./presentation.sass";
import { btnTranslate, presentationTranslate } from "../../../../i18n/translatedMessages";

const PresentationForm = ({
  presentationData,
  urlPdf,
  videoUrlEmbed,
  index,
  setPdf,
  handlePatch,
  handleChange,
}) => {
  const onDrop = useCallback((acceptedFiles) => {
    const [targetFile] = acceptedFiles;
    setPdf({ index: index, file: targetFile });
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    maxFiles: 1,
    accept: ".pdf",
  });

  return (
    <>
      <div
        style={{ maxWidth: "400px" }}
        className="row d-flex justify-content-center container-presentation"
      >
        <div className="m-3">
          <div className="d-flex flex-column">
            <div className="text-center titulo-redes">
              <strong>{presentationTranslate.presentationTitle}</strong>
            </div>
            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label className="w-100">
                <div className="text-center">
                  <span className="titulo-redes">
                    {" "}
                    <BsYoutube style={{ color: "#40c8ff" }} className="me-2" />{" "}
                    {presentationTranslate.uploadVideoLink}
                  </span>
                </div>
              </Form.Label>
              <Form.Control
                type="text"
                name="video_presentation_url"
                placeholder="Youtube URL"
                value={presentationData ? presentationData.video_presentation_url : ""}
                onChange={(e) => {
                  handleChange(e);
                }}
              />
            </Form.Group>
            {!urlPdf && (
              <Form.Group>
                <Form.Label className="mb-4 w-100">
                  <div className="text-center">
                    <span className="titulo-redes">
                      {" "}
                      <BsFillFileEarmarkFill style={{ color: "#40c8ff" }} className="me-2" />{" "}
                      {presentationTranslate.uploadLetterPresentation}
                    </span>
                  </div>{" "}
                </Form.Label>
                <div
                  className="inputPdfUpload d-flex justify-content-evenly align-items-center"
                  {...getRootProps()}
                >
                  <input {...getInputProps()} />
                  {isDragActive ? (
                    "Suelta el PDF aquí ..."
                  ) : (
                    <>
                      <div className="w-50">
                        <span>{presentationTranslate.uploadFileDesc}</span>
                      </div>
                      <div>
                        <BiDownload className="me-4" size={50} />
                      </div>
                    </>
                  )}
                </div>
              </Form.Group>
            )}
            <div>
              <div className="my-3 text-center">
                <Button
                  variant="primary"
                  onClick={() => {
                    handlePatch();
                  }}
                  className={"btn rounded-pill btn-moveStep"}
                >
                  {btnTranslate.saveButton}
                </Button>
              </div>
            </div>
            <hr />
            <div className="text-center titulo-redes">
              <strong>{presentationTranslate.yourFile}</strong>
            </div>

            {urlPdf && (
              <>
                <div>
                  <div className="text-center">
                    <span className="titulo-redes">
                      {" "}
                      <BsFillFileEarmarkCheckFill
                        style={{ color: "#40c8ff" }}
                        className="me-2"
                      />{" "}
                      {presentationTranslate.yourFileTitle}
                    </span>
                  </div>
                  <div className="d-flex justify-content-center">
                    <a className="download-link" href={urlPdf ? urlPdf : ""} target="__blank">
                      <BsFillCloudArrowDownFill
                        style={{ color: "#40c8ff" }}
                        className="me-2"
                        size={20}
                      />{" "}
                      {presentationTranslate.yourFileDownload}
                    </a>
                  </div>
                </div>
              </>
            )}
            {videoUrlEmbed && (
              <>
                <div className="">
                  <div className="text-center mb-3">
                    <span className="titulo-redes">
                      {" "}
                      <BsFillCameraVideoFill style={{ color: "#40c8ff" }} className="me-2" />{" "}
                      {presentationTranslate.videoPresentation}
                    </span>
                  </div>
                  <div>
                    <iframe
                      title="Video Presentación"
                      width={"100%"}
                      height={"300px"}
                      src={videoUrlEmbed ? `https://www.youtube.com/embed/${videoUrlEmbed}` : ""}
                      frameborder="0"
                      allowfullscreen
                    ></iframe>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default PresentationForm;
